import Model from "./base/model";

class OrderIntegrationTask extends Model {
  resourceName() {
    return "order_integration_tasks";
  }

  fields() {
    return {
      order_id: "",
      taskable_type: "",
      taskable_id: "",
      type: "",
      status: "",
      retries: "",
      last_error_message: "",
    };
  }
}

export default new OrderIntegrationTask();
